import closeIcon from '../assets/icons/close.svg';
import settings from '../assets/icons/settings.svg';

export default {
  closeIcon,
  settings,
};
